// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"d7a3952a","998":"4a8f9eb5"}[chunkId] + ".chunk.css";
};